import { createContextAwareHook } from './useContextAwareHook';
import {
  useGetOrganicSoilQuery,
  usePublicGetOrganicSoilQuery,
  useGetOrganicSoilDefaultsQuery,
  usePublicGetOrganicSoilDefaultsQuery,
  useUpdateOrganicSoilMutation
} from '../features/modules/organicSoilApiSlice';

/**
 * Returns a hook that automatically selects between public and private APIs
 * for getting organic soil data based on the current route.
 */
export const useContextAwareGetOrganicSoil = createContextAwareHook(
  useGetOrganicSoilQuery,
  usePublicGetOrganicSoilQuery
);

/**
 * Returns a hook that automatically selects between public and private APIs
 * for getting organic soil defaults based on the current route.
 */
export const useContextAwareGetOrganicSoilDefaults = createContextAwareHook(
  useGetOrganicSoilDefaultsQuery,
  usePublicGetOrganicSoilDefaultsQuery
);

// Export mutation hooks directly
export {
  useUpdateOrganicSoilMutation
}; 